import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';

const Privacy: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="container py-12">
        <div className="bg-white rounded-2xl shadow-apple p-8 max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-8">プライバシーポリシー</h1>
          
          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-semibold mb-4">1. 個人情報の取り扱いについて</h2>
              <p className="text-gray-700">
                ForceAI（以下「当社」）は、RepliGo（レプリゴ）（以下「本サービス」）における個人情報の取り扱いについて、
                以下のとおりプライバシーポリシーを定めます。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">2. 収集する個人情報</h2>
              <p className="text-gray-700">
                当社は、以下の個人情報を収集します：
              </p>
              <ul className="list-disc ml-6 mt-2 text-gray-700">
                <li>メールアドレス</li>
                <li>Googleアカウント情報（Google ID、アクセストークン、リフレッシュトークン）</li>
                <li>Google Business Profileの店舗情報（店舗名、住所等）</li>
                <li>Google Business Profileの口コミ情報</li>
                <li>その他、本サービスの提供に必要な情報</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">2-2. Googleアカウント連携について</h2>
              <p className="text-gray-700">
                本サービスでは、Google Business Profile APIを利用するため、Googleアカウントとの連携（OAuth 2.0認証）を行います。
                連携により取得した情報は以下の目的でのみ使用します：
              </p>
              <ul className="list-disc ml-6 mt-2 text-gray-700">
                <li>Google Business Profileに登録された店舗情報の取得</li>
                <li>口コミデータの取得・同期</li>
                <li>口コミへの返信機能の提供</li>
              </ul>
              <p className="text-gray-700 mt-2">
                Googleから取得したアクセストークンは暗号化して保存し、サービス提供以外の目的では使用しません。
                ユーザーはいつでもGoogleアカウント連携を解除することができます。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">3. 個人情報の利用目的</h2>
              <p className="text-gray-700">
                当社は、収集した個人情報を以下の目的で利用します：
              </p>
              <ul className="list-disc ml-6 mt-2 text-gray-700">
                <li>本サービスの提供・運営</li>
                <li>お問い合わせへの対応</li>
                <li>サービスの改善・新機能の開発</li>
                <li>重要なお知らせの通知</li>
                <li>法令に基づく対応</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">4. 個人情報の管理</h2>
              <p className="text-gray-700">
                当社は、個人情報の正確性及び安全性を確保するために、セキュリティ対策を実施し、
                個人情報の漏洩、滅失または毀損を防止します。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">5. 個人情報の第三者提供</h2>
              <p className="text-gray-700">
                当社は、以下の場合を除き、個人情報を第三者に提供いたしません：
              </p>
              <ul className="list-disc ml-6 mt-2 text-gray-700">
                <li>ご本人の同意がある場合</li>
                <li>法令に基づく場合</li>
                <li>人の生命、身体または財産の保護のために必要がある場合</li>
                <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合</li>
                <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">6. 個人情報の開示・訂正・利用停止</h2>
              <p className="text-gray-700">
                当社は、ご本人からの個人情報の開示、訂正、利用停止等のご要請に対して、
                合理的な範囲で速やかに対応いたします。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">7. アクセス解析ツール</h2>
              <p className="text-gray-700">
                当社は、サービスの利用状況を把握するため、Googleアナリティクス等のアクセス解析ツールを使用しています。
                これらのツールは、Cookieを使用して個人を特定できない形式で情報を収集します。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">8. プライバシーポリシーの変更</h2>
              <p className="text-gray-700">
                当社は、必要に応じて本プライバシーポリシーを変更することがあります。
                変更後のプライバシーポリシーは、本サービス上での告知をもって効力を生じるものとします。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">9. お問い合わせ</h2>
              <p className="text-gray-700">
                ご不明点やお問い合わせがある場合は、お問い合わせフォームよりご連絡ください。
              </p>
            </section>

            <div className="text-sm text-gray-500 mt-12">
              <p>制定日：2025年5月25日</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Privacy; 